import ModelInterface from 'src/models/ModelInterface'
import {RawUser, UserOrg} from '@/types/entity/RawUser'
import store from '@/store/index'
import {wrapMask} from '@/lib/phone'

class User extends ModelInterface<RawUser> {

  constructor (data: RawUser) {
    super(data)
  }

  public getFirstName () {
    return this.data.first_name || '';
  }

  public getLastName () {
    return this.data.last_name || '';
  }

  public getMiddleName () {
    return this.data.middle_name || '';
  }

  public getRoles () {
    return this.data.roles;
  }

  public getUpic () {
    return this.data.upic || ''
  }

  public getOrgs () {
    return this.data.orgs || false
  }

  public getStatus () {
    return this.data.status
  }

  public getContacts () {
    return this.data.contacts || []
  }

  public getLang () {
    return this.data.lang || ''
  }

  public getLogin () {
    return this.data.login
  }

  public getPhone () {
    return this.data.phone
  }

  public getMaskedPhone () {
    return wrapMask(this.getPhone())
  }

  public getEmail () {
    return this.data.email
  }

  public getNote () {
    return this.data.note || ''
  }

  public getPosts () {
    let orgs = this.getOrgs() as UserOrg[]
    if (orgs && orgs.length) {
      let posts = orgs.map(org => {
        return org.note;
      });
      if (posts.length) {
        return posts;
      }
    }
    return false;
  }

  public getPostsText () {
    if (this.getPosts()) {
      let posts = this.getPosts() as []
      return posts.join(', ')
    }
    return ''
  }

  /**
   * User full name
   * @returns {String}
   */
  public getFullName () {
    let fullName = ''
    fullName += this.data.last_name ? this.data.last_name + ' ' : ''
    fullName += this.data.first_name ? this.data.first_name + ' ' : ''
    fullName += this.data.middle_name ? this.data.middle_name + ' ' : ''
    return fullName;
  }

  /**
   * Check user roles
   * @returns {Boolean}
   */
  public checkRole (role: string): boolean {
    return this.getRoles().includes(role);
  }

  public getMsgrs () {
    return this.data.msgrs || [];
  }

  get last_name () {
    return this.getLastName()
  }
  get first_name () {
    return this.getFirstName()
  }
  get middle_name () {
    return this.getMiddleName()
  }
}

export default User
